export enum CLIENT_NAMES {
  'CBV' = 'cbv',
  'AEIK' = 'aeik',
  'KSPERSONAL' = 'kspersonal',
  'TRAININGROOM' = 'trainingroom',
  'ALPHA25' = 'alpha25',
  'AMGYM'= 'amgym',
  'CRETANWARRIORS'= 'cretanwarriors',
  'FLEX' = 'flex',
  'HERYC' = 'heryc',
  'SPORTPOINT' = 'sportpoint',
  'VITRUVIAN' = 'vitruvian',
}

export type CLIENT_NAME = CLIENT_NAMES | undefined;
